import React from "react";

const ZYPHERAI = () => {
  const heroImageUrl = process.env.PUBLIC_URL + "/zypherai.png"; // Assuming zypherai.png is in public directory
  const zypherai2ImageUrl = process.env.PUBLIC_URL + "/zypherai2.png"; // Assuming zypherai2.png is in public directory
  const videoUrl = "https://www.youtube.com/embed/YxBF1yfZ1jM"; // Embedded YouTube URL

  return (
    <div className="bg-black text-white font-secondary">
      {/* Hero Section */}
      <section
        className="relative w-full h-[25vh] sm:h-[60vh] md:h-[80vh] bg-cover bg-center flex items-center justify-center text-center"
        style={{ backgroundImage: `url(${heroImageUrl})` }}
      >
        <div className="absolute bottom-[14.5%] right-[5.5%] z-10">
          <a
            href="https://zypher-ai.vercel.app/"
            className="inline-block px-6 py-2 text-[0.6rem] sm:px-14 sm:py-4 sm:text-[1.2rem] font-secondary font-bold text-black bg-white rounded-[10px] transition-colors duration-300 hover:bg-gray-200"
          >
            Get Started
          </a>
        </div>
      </section>

      {/* Section 1: Description below hero image */}
      <section className="py-16 max-w-[1200px] mx-auto px-10 text-center">
        <p className="text-[1.1rem] text-[#bfc5c5] leading-relaxed mb-6">
          Our innovative solutions demystify complex algorithms, enabling
          healthcare providers to understand the rationale behind AI-driven
          recommendations while streamlining processes to elevate efficiency.
        </p>
      </section>

      {/* Section 2: ZYPHER AI Heading and Intro */}
      <section className="py-16 max-w-[1200px] mx-auto px-10 text-center">
        <h2 className="font-primary text-[2.7rem] text-white mb-2 text-center">
          ZYPHER AI
        </h2>
        <p className="text-[1.1rem] text-[#bfc5c5] leading-relaxed mb-6">
          ZYPHER AI is at the forefront of transforming healthcare through
          explainable artificial intelligence, empowering professionals with
          transparent insights that enhance decision-making and improve patient
          outcomes.
        </p>
        <a
          href="https://zypher-ai.vercel.app/"
          className="inline-block px-12 py-3 text-[1.1rem] font-secondary font-bold text-white border-2 border-white rounded-full transition-colors duration-300 hover:bg-white hover:text-black"
        >
          Find out more
        </a>
      </section>

      {/* Section 3: Image and Text */}
      <section className="py-16 max-w-[1200px] mx-auto px-10 text-center">
        <img
          src={zypherai2ImageUrl}
          alt="ZYPHER AI Interface"
          className="block max-w-[80vw] h-auto mx-auto my-10 rounded-xl shadow-lg"
        />
        <p className="text-[1.1rem] text-[#bfc5c5] leading-relaxed mb-6">
          By fostering trust between patients and providers through clear
          communication, ZYPHER AI paves the way for a healthier and more
          efficient future in healthcare.
        </p>
      </section>

      {/* Section 4: Embedded Video */}
      <section className="py-16 max-w-[1200px] mx-auto px-10 text-center">
        <div className="relative overflow-hidden pb-[56.25%] max-w-[800px] mx-auto my-8">
          <iframe
            src={videoUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="absolute left-0 top-0 w-full h-full rounded-lg"
          ></iframe>
        </div>
        <p className="text-[1.1rem] text-[#bfc5c5] leading-relaxed mb-8">
          Ready to unlock the potential of AI for your success? Let's embark on
          this transformative journey together.
        </p>
      </section>
    </div>
  );
};

export default ZYPHERAI;
